import React, { useState } from "react";
import "./index.css";
import ImgAmigoLeo from "../../assets/images/pngs/LogoAmigoLeo.png";
import storage from "../../services/storage";

export default function FooterLogado() {
  const [user] = useState(storage.get("USUARIO"));

  return (
    <>
      {/* Versão Desktop */}
      <div className="footerLogado desktop mt-5">
        {/* Barra de cores igual ao header */}
        <div className="footer-color-bar">
          <div style={{ flex: 1, background: "#fab206" }}></div>
          <div style={{ flex: 1, background: "#1a805b" }}></div>
          <div style={{ flex: 1, background: "#fff001" }}></div>
          <div style={{ flex: 1, background: "#fab206" }}></div>
          <div style={{ flex: 1, background: "#e76801" }}></div>
          <div style={{ flex: 1, background: "#124735" }}></div>
        </div>

        {/* Conteúdo do footer */}
        <div className="footer-content">
          {/* Logo */}
          <div className="footer-logo-container">
            <img
              src={ImgAmigoLeo}
              alt="logo amigo leo"
              className="footer-logo"
            />
          </div>

          {/* Informações da empresa */}
          <div className="footer-info">
            <div className="footer-company-name">
              Leo Madeiras, Máquinas e Ferragens
            </div>
            <div className="footer-address">
              Rua Doutor Carlos Roberto Presgrave de Melo, 21 - 0800-591-0127 -
              CEP: 06422-110 - São Paulo/SP
            </div>
            <div className="footer-documents">
              CNPJ: 61.069.373/0001-03 | Inscrição Estadual: 112.625.312.111
            </div>
          </div>
        </div>
      </div>

      {/* Versão Mobile */}
      <div className="footerLogado mobile mt-5">
        {/* Barra de cores - estilo da imagem */}
        <div className="footer-color-bar">
          <div style={{ flex: 1.2, background: "#fab206" }}></div>
          <div style={{ flex: 1.5, background: "#124735" }}></div>
          <div style={{ flex: 1, background: "#fff001" }}></div>
          <div style={{ flex: 1.2, background: "#fab206" }}></div>
          <div style={{ flex: 1.5, background: "#124735" }}></div>
        </div>

        {/* Conteúdo do footer */}
        <div className="footer-content">
          {/* Logo */}
          <div className="footer-logo-container">
            <img
              src={ImgAmigoLeo}
              alt="logo amigo leo"
              className="footer-logo"
            />
          </div>

          {/* Informações da empresa */}
          <div className="footer-info">
            <div className="footer-company-name">
              Leo Madeiras, Máquinas e Ferragens
            </div>
            <div className="footer-address">
              Rua Doutor Carlos Roberto Presgrave de Melo, 21
            </div>
            <div className="footer-address">
              0800-591-0127 - CEP: 06422-110 - São Paulo/SP
            </div>
            <div className="footer-documents">
              CNPJ: 61.069.373/0001-03 | Inscrição
            </div>
            <div className="footer-documents">Estadual: 112.625.312.111</div>
          </div>
        </div>
      </div>
    </>
  );
}
